import { TranslationFilterCriteria } from "../objects/translationFilterCriteria";

export const GOOGLE_SEPARATOR = ' *;* ';

export const EMPTY_TRANSLATION_FILTER: TranslationFilterCriteria = {
    key_name: "",
    value_lang: "",
    target_lang: "",
    empty_column: "none"
};